import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZAssetkpiData = z.object({
  kpi_definition_id: z.string(),
  timestamp: z.string().nullable(),
  kpi_name: z.string(),
  kpi_value: z.number().nullable(),
  is_custom_kpi: z.boolean(),
  units: z.string(),
  colorValue: z.string(),
  formattedValue: z.string().nullable(),
  execution_status: z.string().nullable()
})

export const ZDeviceKPIDetailsData = z.object({
  kpi_definition_id: z.string(),
  timestamp: z.string().nullable(),
  kpi_name: z.string(),
  kpi_value: z.number().nullable(),
  is_custom_kpi: z.boolean(),
  units: z.string(),
  colorValue: z.string(),
  formattedValue: z.string().nullable(),
  execution_status: z.string().nullable()
})

export const ZregisterData = z.object({
  device_id: z.string(),
  device_name: z.string(),
  kpiData: z.array(ZDeviceKPIDetailsData)
})

export const ZHeaderData = z.object({
  asset_id: z.string(),
  asset_name: z.string(),
  tenant_id: z.string(),
  assetKPIs: z.array(ZAssetkpiData),
  devices: z.array(ZregisterData)
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZHeaderData
})

export type headerSummaryAssetKPIDashboard = z.infer<typeof ZHeaderData>
export type headerDataAssetKPIDashboard = z.infer<typeof ZApiResponse>

export async function getAssetDashboardHeaderKPISummary (
  siteId: string,
  assetId: string,
  graphName: string,
  requestParameter: any,
  isdefault: boolean,
  onSuccess: (HealthScoreAssetDashboard: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/kpirest/api/v1/udp/tiq/dashboard/assetStatus/summary/${siteId}/${assetId}?graphName=${graphName}&isDefault=${isdefault.toString()}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else if (response.status === 204) {
        onFailure('No Data Found', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
